import { render, staticRenderFns } from "./SelectionBase.vue?vue&type=template&id=6af03b2c&lang=pug"
import script from "./SelectionBase.vue?vue&type=script&lang=js"
export * from "./SelectionBase.vue?vue&type=script&lang=js"
import style0 from "./SelectionBase.vue?vue&type=style&index=0&id=6af03b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports